import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pioneer-route-not-found',
  templateUrl: './route-not-found.component.html',
  styleUrls: [ './route-not-found.component.css' ]
})
export class RouteNotFoundComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/route-not-found/route-not-found.component.ts